import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/hire_react/why_choose_react.webp";

function Whychoosenlp() {
  return (
    <section
      className="rapid_free_services p-100 nlp_why_choose hire_ios_why_choose hire_react_choose"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={10} lg={8} className="m-auto text-center">
            <h3 className="h3_head" style={{ color: "#fff" }}>
              Why Choose TekRevol to Hire ReactJS Developers
            </h3>
            <p style={{ color: "#fff" }}>
              Our teams at TekRevol include ReactJS developers with adequate
              background and experience in development functions. Our services
              range from the development of high-end, cloud-optimized, and good
              user interfaces in web applications that support your business. We
              remain updated with the new technologies and trending methods, so
              we provide not only reliable applications but creative, optimizing
              ones. We develop integrated ReactJS solutions based on client’s
              specific needs with a primary focus on successfully advancing your
              business.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-4 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5 style={{ color: "#fff" }}>Proven Expertise</h5>
                <p>
                  Our developers have extensive experience in delivering
                  top-notch ReactJS solutions across various industries.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5 style={{ color: "#fff" }}>Advanced Technical Skills</h5>
                <p>
                  We utilize the latest ReactJS tools and technologies to ensure
                  your applications are modern, scalable, and efficient.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5 style={{ color: "#fff" }}>Custom Solutions</h5>
                <p>
                  We tailor our services to meet your unique business
                  requirements, ensuring optimal results and high performance.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5 style={{ color: "#fff" }}>Agile Development Process</h5>
                <p>
                  Our agile methodology ensures flexibility, faster delivery,
                  and the ability to adapt to changing project needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                05
              </div>
              <div className="rapid_content">
                <h5 style={{ color: "#fff" }}>Robust Code Quality</h5>
                <p>
                  We prioritize clean, maintainable, and high-quality code to
                  ensure long-term sustainability and ease of updates.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                06
              </div>
              <div className="rapid_content">
                <h5 style={{ color: "#fff" }}>
                  Continuous Learning and Innovation
                </h5>
                <p>
                  Our developers stay updated with the latest industry trends
                  and innovations, ensuring your projects benefit from the most
                  current practices.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-md-4 mt-3">
            <Link
              style={{ background: "#f47a14", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Hire Your Developers Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosenlp;
